import { Theme } from '@fluentui/react-components';

export const corptaxDefaultLightTheme: Theme = {
    borderRadiusNone: '0',
    borderRadiusSmall: '2px',
    borderRadiusMedium: '4px',
    borderRadiusLarge: '6px',
    borderRadiusXLarge: '8px',
    borderRadiusCircular: '10000px',

    fontSizeBase100: '10px',
    fontSizeBase200: '12px',
    fontSizeBase300: '14px',
    fontSizeBase400: '16px',
    fontSizeBase500: '20px',
    fontSizeBase600: '24px',
    fontSizeHero700: '28px',
    fontSizeHero800: '32px',
    fontSizeHero900: '40px',
    fontSizeHero1000: '68px',

    lineHeightBase100: '14px',
    lineHeightBase200: '16px',
    lineHeightBase300: '20px',
    lineHeightBase400: '22px',
    lineHeightBase500: '28px',
    lineHeightBase600: '32px',
    lineHeightHero700: '36px',
    lineHeightHero800: '40px',
    lineHeightHero900: '52px',
    lineHeightHero1000: '92px',

    fontFamilyBase:
        "'Segoe, UI', 'Segoe, UI, Web, (West, European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica, Neue', sans-serif",
    fontFamilyMonospace: "Consolas, 'Courier, New', Courier, monospace",
    fontFamilyNumeric:
        "Bahnschrift, 'Segoe, UI', 'Segoe, UI, Web, (West, European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica, Neue', sans-serif",

    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemibold: 600,
    fontWeightBold: 700,

    strokeWidthThin: '1px',
    strokeWidthThick: '2px',
    strokeWidthThicker: '3px',
    strokeWidthThickest: '4px',

    spacingHorizontalNone: '0',
    spacingHorizontalXXS: '2px',
    spacingHorizontalXS: '4px',
    spacingHorizontalSNudge: '6px',
    spacingHorizontalS: '8px',
    spacingHorizontalMNudge: '10px',
    spacingHorizontalM: '12px',
    spacingHorizontalL: '16px',
    spacingHorizontalXL: '20px',
    spacingHorizontalXXL: '24px',
    spacingHorizontalXXXL: '32px',

    spacingVerticalNone: '0',
    spacingVerticalXXS: '2px',
    spacingVerticalXS: '4px',
    spacingVerticalSNudge: '6px',
    spacingVerticalS: '8px',
    spacingVerticalMNudge: '10px',
    spacingVerticalM: '12px',
    spacingVerticalL: '16px',
    spacingVerticalXL: '20px',
    spacingVerticalXXL: '24px',
    spacingVerticalXXXL: '32px',

    durationUltraFast: '50ms',
    durationFaster: '100ms',
    durationFast: '150ms',
    durationNormal: '200ms',
    durationGentle: '250ms',
    durationSlow: '300ms',
    durationSlower: '400ms',
    durationUltraSlow: '500ms',

    curveAccelerateMax: 'cubic-bezier(0.9,0.1,1,0.2)',
    curveAccelerateMid: 'cubic-bezier(1,0,1,1)',
    curveAccelerateMin: 'cubic-bezier(0.8,0,0.78,1)',
    curveDecelerateMax: 'cubic-bezier(0.1,0.9,0.2,1)',
    curveDecelerateMid: 'cubic-bezier(0,0,0,1)',
    curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
    curveEasyEaseMax: 'cubic-bezier(0.8,0,0.2,1)',
    curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
    curveLinear: 'cubic-bezier(0,0,1,1)',

    colorNeutralForeground1: '#222222',
    colorNeutralForeground1Hover: '#222222',
    colorNeutralForeground1Pressed: '#222222',
    colorNeutralForeground1Selected: '#222222',
    colorNeutralForeground2: '#222222',
    colorNeutralForeground2Hover: '#222222',
    colorNeutralForeground2Pressed: '#222222',
    colorNeutralForeground2Selected: '#222222',
    colorNeutralForeground2BrandHover: '#044B77',
    colorNeutralForeground2BrandPressed: '#002C45',
    colorNeutralForeground2BrandSelected: '#003B5C',
    colorNeutralForeground3: '#54585A',
    colorNeutralForeground3Hover: '#222222',
    colorNeutralForeground3Pressed: '#222222',
    colorNeutralForeground3Selected: '#222222',
    colorNeutralForeground3BrandHover: '#044B77',
    colorNeutralForeground3BrandPressed: '#002C45',
    colorNeutralForeground3BrandSelected: '#003B5C',
    colorNeutralForeground4: '#97999B',
    colorNeutralForegroundDisabled: '#F5F5F5',
    colorNeutralForegroundInvertedDisabled: 'rgba(255, 255, 255, 0.4)',
    colorBrandForegroundLink: '#075A92',
    colorBrandForegroundLinkHover: '#044B77',
    colorBrandForegroundLinkPressed: '#003B5C',
    colorBrandForegroundLinkSelected: '#075A92',
    colorNeutralForeground2Link: '#222222',
    colorNeutralForeground2LinkHover: '#222222',
    colorNeutralForeground2LinkPressed: '#222222',
    colorNeutralForeground2LinkSelected: '#222222',
    colorCompoundBrandForeground1: '#003B5C',
    colorCompoundBrandForeground1Hover: '#044B77',
    colorCompoundBrandForeground1Pressed: '#002C45',
    colorBrandForeground1: '#003B5C',
    colorBrandForeground2: '#075A92',
    colorBrandForeground2Hover: '#044B77',
    colorBrandForeground2Pressed: '#003B5C',
    colorNeutralForeground1Static: '#222222',
    colorNeutralForegroundStaticInverted: '#ffffff',
    colorNeutralForegroundInverted: '#ffffff',
    colorNeutralForegroundInvertedHover: '#ffffff',
    colorNeutralForegroundInvertedPressed: '#ffffff',
    colorNeutralForegroundInvertedSelected: '#ffffff',
    colorNeutralForegroundInverted2: '#ffffff',
    colorNeutralForegroundOnBrand: '#ffffff',
    colorNeutralForegroundInvertedLink: '#ffffff',
    colorNeutralForegroundInvertedLinkHover: '#ffffff',
    colorNeutralForegroundInvertedLinkPressed: '#ffffff',
    colorNeutralForegroundInvertedLinkSelected: '#ffffff',
    colorBrandForegroundInverted: '#22AEFD',
    colorBrandForegroundInvertedHover: '#43BAFD',
    colorBrandForegroundInvertedPressed: '#22AEFD',
    colorBrandForegroundOnLight: '#003B5C',
    colorBrandForegroundOnLightHover: '#044B77',
    colorBrandForegroundOnLightPressed: '#001D2E',
    colorBrandForegroundOnLightSelected: '#002C45',
    colorNeutralBackground1: '#ffffff',
    colorNeutralBackground1Hover: '#f5f5f5',
    colorNeutralBackground1Pressed: '#DDDEDF',
    colorNeutralBackground1Selected: '#EAEBEB',
    colorNeutralBackground2: '#FAFAFA',
    colorNeutralBackground2Hover: '#EFF0F0',
    colorNeutralBackground2Pressed: '#D7D9D9',
    colorNeutralBackground2Selected: '#E2E3E4',
    colorNeutralBackground3: '#f5f5f5',
    colorNeutralBackground3Hover: '#EAEBEB',
    colorNeutralBackground3Pressed: '#D1D3D4',
    colorNeutralBackground3Selected: '#DDDEDF',
    colorNeutralBackground4: '#EFF0F0',
    colorNeutralBackground4Hover: '#FAFAFA',
    colorNeutralBackground4Pressed: '#f5f5f5',
    colorNeutralBackground4Selected: '#ffffff',
    colorNeutralBackground5: '#EAEBEB',
    colorNeutralBackground5Hover: '#f5f5f5',
    colorNeutralBackground5Pressed: '#EFF0F0',
    colorNeutralBackground5Selected: '#fafafa',
    colorNeutralBackground6: '#E2E3E4',
    colorNeutralBackgroundInverted: '#2F3030',
    colorNeutralBackgroundStatic: '#2F3030',
    colorNeutralBackgroundAlpha: 'rgba(255, 255, 255, 0.5)',
    colorNeutralBackgroundAlpha2: 'rgba(255, 255, 255, 0.8)',
    colorSubtleBackground: 'transparent',
    colorSubtleBackgroundHover: '#f5f5f5',
    colorSubtleBackgroundPressed: '#E2E3E4',
    colorSubtleBackgroundSelected: '#EAEBEB',
    colorSubtleBackgroundLightAlphaHover: 'rgba(255, 255, 255, 0.7)',
    colorSubtleBackgroundLightAlphaPressed: 'rgba(255, 255, 255, 0.5)',
    colorSubtleBackgroundLightAlphaSelected: 'transparent',
    colorSubtleBackgroundInverted: 'transparent',
    colorSubtleBackgroundInvertedHover: 'rgba(0, 0, 0, 0.1)',
    colorSubtleBackgroundInvertedPressed: 'rgba(0, 0, 0, 0.3)',
    colorSubtleBackgroundInvertedSelected: 'rgba(0, 0, 0, 0.2)',
    colorTransparentBackground: 'transparent',
    colorTransparentBackgroundHover: 'transparent',
    colorTransparentBackgroundPressed: 'transparent',
    colorTransparentBackgroundSelected: 'transparent',
    colorNeutralBackgroundDisabled: '#F5F5F5',
    colorNeutralBackgroundInvertedDisabled: 'rgba(255, 255, 255, 0.1)',
    colorNeutralStencil1: '#E2E3E4',
    colorNeutralStencil2: '#FAFAFA',
    colorNeutralStencil1Alpha: 'rgba(0, 0, 0, 0.1)',
    colorNeutralStencil2Alpha: 'rgba(0, 0, 0, 0.05)',
    colorBackgroundOverlay: 'rgba(0, 0, 0, 0.4)',
    colorScrollbarOverlay: 'rgba(0, 0, 0, 0.5)',
    colorBrandBackground: '#003B5C',
    colorBrandBackgroundHover: '#044B77',
    colorBrandBackgroundPressed: '#002C45',
    colorBrandBackgroundSelected: '#002C45',
    colorCompoundBrandBackground: '#003B5C',
    colorCompoundBrandBackgroundHover: '#044B77',
    colorCompoundBrandBackgroundPressed: '#002C45',
    colorBrandBackgroundStatic: '#003B5C',
    colorBrandBackground2: '#EBF6FD',
    colorBrandBackground2Hover: '#C9EAFD',
    colorBrandBackground2Pressed: '#A8DEFD',
    colorBrandBackgroundInverted: '#ffffff',
    colorBrandBackgroundInvertedHover: '#EBF6FD',
    colorBrandBackgroundInvertedPressed: '#A8DEFD',
    colorBrandBackgroundInvertedSelected: '#C9EAFD',
    colorNeutralStrokeAccessible: '#616567',
    colorNeutralStrokeAccessibleHover: '#54585A',
    colorNeutralStrokeAccessiblePressed: '#484B4C',
    colorNeutralStrokeAccessibleSelected: '#484B4C',
    colorNeutralStroke1: '#D1D3D4',
    colorNeutralStroke1Hover: '#C3C5C6',
    colorNeutralStroke1Pressed: '#97999B',
    colorNeutralStroke1Selected: '#A5A7A9',
    colorNeutralStroke2: '#DDDEDF',
    colorNeutralStroke3: '#EFF0F0',
    colorNeutralStrokeSubtle: '#DDDEDF',
    colorNeutralStrokeOnBrand: '#ffffff',
    colorNeutralStrokeOnBrand2: '#ffffff',
    colorNeutralStrokeOnBrand2Hover: '#ffffff',
    colorNeutralStrokeOnBrand2Pressed: '#ffffff',
    colorNeutralStrokeOnBrand2Selected: '#ffffff',
    colorBrandStroke1: '#003B5C',
    colorBrandStroke2: '#A8DEFD',
    colorBrandStroke2Hover: '#65C6FD',
    colorBrandStroke2Pressed: '#008DDD',
    colorBrandStroke2Contrast: '#A8DEFD',
    colorCompoundBrandStroke: '#075A92',
    colorCompoundBrandStrokeHover: '#044B77',
    colorCompoundBrandStrokePressed: '#003B5C',
    colorNeutralStrokeDisabled: '#E2E3E4',
    colorNeutralStrokeInvertedDisabled: 'rgba(255, 255, 255, 0.4)',
    colorTransparentStroke: 'transparent',
    colorTransparentStrokeInteractive: 'transparent',
    colorTransparentStrokeDisabled: 'transparent',
    colorNeutralStrokeAlpha: 'rgba(0, 0, 0, 0.05)',
    colorNeutralStrokeAlpha2: 'rgba(255, 255, 255, 0.2)',
    colorStrokeFocus1: '#ffffff',
    colorStrokeFocus2: '#222222',
    colorNeutralShadowAmbient: 'rgba(0,0,0,0.12)',
    colorNeutralShadowKey: 'rgba(0,0,0,0.14)',
    colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.06)',
    colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.07)',
    colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.20)',
    colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.24)',
    colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
    colorBrandShadowKey: 'rgba(0,0,0,0.25)',

    colorBrandBackground3Static: '#002C45',
    colorBrandBackground4Static: '#002C45',
    colorNeutralCardBackground: '#FAFAFA',
    colorNeutralCardBackgroundHover: '#ffffff',
    colorNeutralCardBackgroundPressed: '#F5F5F5',
    colorNeutralCardBackgroundSelected: '#EAEBEB',
    colorNeutralCardBackgroundDisabled: '#EFF0F0',

    colorPaletteRedBackground1: '#FFE7EB',
    colorPaletteRedBackground2: '#F3BAC4',
    colorPaletteRedBackground3: '#D1344F',
    colorPaletteRedForeground1: '#A6293F',
    colorPaletteRedForeground2: '#7C1F2F',
    colorPaletteRedForeground3: '#D1344F',
    colorPaletteRedBorderActive: '#D1344F',
    colorPaletteRedBorder1: '#F3BAC4',
    colorPaletteRedBorder2: '#D1344F',
    colorPaletteGreenBackground1: '#EEFFE8',
    colorPaletteGreenBackground2: '#B3DBA3',
    colorPaletteGreenBackground3: '#509E2F',
    colorPaletteGreenForeground1: '#0E700E',
    colorPaletteGreenForeground2: '#094509',
    colorPaletteGreenForeground3: '#509E2F',
    colorPaletteGreenBorderActive: '#509E2F',
    colorPaletteGreenBorder1: '#B3DBA3',
    colorPaletteGreenBorder2: '#509E2F',
    colorPaletteDarkOrangeBackground1: '#FFEEDE',
    colorPaletteDarkOrangeBackground2: '#FCCDA2',
    colorPaletteDarkOrangeBackground3: '#F68D2E',
    colorPaletteDarkOrangeForeground1: '#C47025',
    colorPaletteDarkOrangeForeground2: '#784516',
    colorPaletteDarkOrangeForeground3: '#F68D2E',
    colorPaletteDarkOrangeBorderActive: '#F68D2E',
    colorPaletteDarkOrangeBorder1: '#FCCDA2',
    colorPaletteDarkOrangeBorder2: '#F68D2E',
    colorPaletteYellowBackground1: '#FFF8E8',
    colorPaletteYellowBackground2: '#FCE4AE',
    colorPaletteYellowBackground3: '#F2A900',
    colorPaletteYellowForeground1: '#8F6400',
    colorPaletteYellowForeground2: '#8F6400',
    colorPaletteYellowForeground3: '#F2A900',
    colorPaletteYellowBorderActive: '#F2A900',
    colorPaletteYellowBorder1: '#FCE4AE',
    colorPaletteYellowBorder2: '#F2A900',
    colorPaletteBerryBackground1: '#fdf5fc',
    colorPaletteBerryBackground2: '#edbbe7',
    colorPaletteBerryBackground3: '#c239b3',
    colorPaletteBerryForeground1: '#af33a1',
    colorPaletteBerryForeground2: '#6d2064',
    colorPaletteBerryForeground3: '#c239b3',
    colorPaletteBerryBorderActive: '#c239b3',
    colorPaletteBerryBorder1: '#edbbe7',
    colorPaletteBerryBorder2: '#c239b3',
    colorPaletteLightGreenBackground1: '#f2fbf2',
    colorPaletteLightGreenBackground2: '#a7e3a5',
    colorPaletteLightGreenBackground3: '#13a10e',
    colorPaletteLightGreenForeground1: '#11910d',
    colorPaletteLightGreenForeground2: '#0b5a08',
    colorPaletteLightGreenForeground3: '#13a10e',
    colorPaletteLightGreenBorderActive: '#13a10e',
    colorPaletteLightGreenBorder1: '#a7e3a5',
    colorPaletteLightGreenBorder2: '#13a10e',
    colorPaletteMarigoldBackground1: '#fefbf4',
    colorPaletteMarigoldBackground2: '#f9e2ae',
    colorPaletteMarigoldBackground3: '#eaa300',
    colorPaletteMarigoldForeground1: '#d39300',
    colorPaletteMarigoldForeground2: '#835b00',
    colorPaletteMarigoldForeground3: '#eaa300',
    colorPaletteMarigoldBorderActive: '#eaa300',
    colorPaletteMarigoldBorder1: '#f9e2ae',
    colorPaletteMarigoldBorder2: '#eaa300',
    colorPaletteRedForegroundInverted: '#dc5e62',
    colorPaletteGreenForegroundInverted: '#359b35',
    colorPaletteYellowForegroundInverted: '#fef7b2',
    colorPaletteDarkRedBackground2: '#d69ca5',
    colorPaletteDarkRedForeground2: '#420610',
    colorPaletteDarkRedBorderActive: '#750b1c',
    colorPaletteCranberryBackground2: '#eeacb2',
    colorPaletteCranberryForeground2: '#6e0811',
    colorPaletteCranberryBorderActive: '#c50f1f',
    colorPalettePumpkinBackground2: '#efc4ad',
    colorPalettePumpkinForeground2: '#712d09',
    colorPalettePumpkinBorderActive: '#ca5010',
    colorPalettePeachBackground2: '#ffddb3',
    colorPalettePeachForeground2: '#8f4e00',
    colorPalettePeachBorderActive: '#ff8c00',
    colorPaletteGoldBackground2: '#ecdfa5',
    colorPaletteGoldForeground2: '#6c5700',
    colorPaletteGoldBorderActive: '#c19c00',
    colorPaletteBrassBackground2: '#e0cea2',
    colorPaletteBrassForeground2: '#553e06',
    colorPaletteBrassBorderActive: '#986f0b',
    colorPaletteBrownBackground2: '#ddc3b0',
    colorPaletteBrownForeground2: '#50301a',
    colorPaletteBrownBorderActive: '#8e562e',
    colorPaletteForestBackground2: '#bdd99b',
    colorPaletteForestForeground2: '#294903',
    colorPaletteForestBorderActive: '#498205',
    colorPaletteSeafoamBackground2: '#a8f0cd',
    colorPaletteSeafoamForeground2: '#00723b',
    colorPaletteSeafoamBorderActive: '#00cc6a',
    colorPaletteDarkGreenBackground2: '#9ad29a',
    colorPaletteDarkGreenForeground2: '#063b06',
    colorPaletteDarkGreenBorderActive: '#0b6a0b',
    colorPaletteLightTealBackground2: '#a6e9ed',
    colorPaletteLightTealForeground2: '#00666d',
    colorPaletteLightTealBorderActive: '#00b7c3',
    colorPaletteTealBackground2: '#9bd9db',
    colorPaletteTealForeground2: '#02494c',
    colorPaletteTealBorderActive: '#038387',
    colorPaletteSteelBackground2: '#94c8d4',
    colorPaletteSteelForeground2: '#00333f',
    colorPaletteSteelBorderActive: '#005b70',
    colorPaletteBlueBackground2: '#a9d3f2',
    colorPaletteBlueForeground2: '#004377',
    colorPaletteBlueBorderActive: '#0078d4',
    colorPaletteRoyalBlueBackground2: '#9abfdc',
    colorPaletteRoyalBlueForeground2: '#002c4e',
    colorPaletteRoyalBlueBorderActive: '#004e8c',
    colorPaletteCornflowerBackground2: '#c8d1fa',
    colorPaletteCornflowerForeground2: '#2c3c85',
    colorPaletteCornflowerBorderActive: '#4f6bed',
    colorPaletteNavyBackground2: '#a3b2e8',
    colorPaletteNavyForeground2: '#001665',
    colorPaletteNavyBorderActive: '#0027b4',
    colorPaletteLavenderBackground2: '#d2ccf8',
    colorPaletteLavenderForeground2: '#3f3682',
    colorPaletteLavenderBorderActive: '#7160e8',
    colorPalettePurpleBackground2: '#c6b1de',
    colorPalettePurpleForeground2: '#341a51',
    colorPalettePurpleBorderActive: '#5c2e91',
    colorPaletteGrapeBackground2: '#d9a7e0',
    colorPaletteGrapeForeground2: '#4c0d55',
    colorPaletteGrapeBorderActive: '#881798',
    colorPaletteLilacBackground2: '#e6bfed',
    colorPaletteLilacForeground2: '#63276d',
    colorPaletteLilacBorderActive: '#b146c2',
    colorPalettePinkBackground2: '#f7c0e3',
    colorPalettePinkForeground2: '#80215d',
    colorPalettePinkBorderActive: '#e43ba6',
    colorPaletteMagentaBackground2: '#eca5d1',
    colorPaletteMagentaForeground2: '#6b0043',
    colorPaletteMagentaBorderActive: '#bf0077',
    colorPalettePlumBackground2: '#d696c0',
    colorPalettePlumForeground2: '#43002b',
    colorPalettePlumBorderActive: '#77004d',
    colorPaletteBeigeBackground2: '#d7d4d4',
    colorPaletteBeigeForeground2: '#444241',
    colorPaletteBeigeBorderActive: '#7a7574',
    colorPaletteMinkBackground2: '#cecccb',
    colorPaletteMinkForeground2: '#343231',
    colorPaletteMinkBorderActive: '#5d5a58',
    colorPalettePlatinumBackground2: '#cdd6d8',
    colorPalettePlatinumForeground2: '#3b4447',
    colorPalettePlatinumBorderActive: '#69797e',
    colorPaletteAnchorBackground2: '#bcc3c7',
    colorPaletteAnchorForeground2: '#202427',
    colorPaletteAnchorBorderActive: '#394146',

    colorStatusSuccessBackground1: '#EEFFE8',
    colorStatusSuccessBackground2: '#B3DBA3',
    colorStatusSuccessBackground3: '#509E2F',
    colorStatusSuccessForeground1: '#0E700E',
    colorStatusSuccessForeground2: '#094509',
    colorStatusSuccessForeground3: '#509E2F',
    colorStatusSuccessBorderActive: '#509E2F',
    colorStatusSuccessForegroundInverted: '#64AA46',
    colorStatusSuccessBorder1: '#B3DBA3',
    colorStatusSuccessBorder2: '#509E2F',
    colorStatusWarningBackground1: '#FFEEDE',
    colorStatusWarningBackground2: '#FCCDA2',
    colorStatusWarningBackground3: '#F68D2E',
    colorStatusWarningForeground1: '#C47025',
    colorStatusWarningForeground2: '#91531B',
    colorStatusWarningForeground3: '#C47025',
    colorStatusWarningBorderActive: '#F68D2E',
    colorStatusWarningForegroundInverted: '#F9B374',
    colorStatusWarningBorder1: '#FCCDA2',
    colorStatusWarningBorder2: '#C47025',
    colorStatusDangerBackground1: '#FFE7EB',
    colorStatusDangerBackground2: '#F3BAC4',
    colorStatusDangerBackground3: '#D1344F',
    colorStatusDangerBackground3Hover: '#A6293F',
    colorStatusDangerBackground3Pressed: '#912437',
    colorStatusDangerForeground1: '#A6293F',
    colorStatusDangerForeground2: '#7C1F2F',
    colorStatusDangerForeground3: '#D1344F',
    colorStatusDangerBorderActive: '#D1344F',
    colorStatusDangerForegroundInverted: '#D74A63',
    colorStatusDangerBorder1: '#F3BAC4',
    colorStatusDangerBorder2: '#D1344F',

    shadow2: '0 0 2px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.14)',
    shadow4: '0 0 2px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.14)',
    shadow8: '0 0 2px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.14)',
    shadow16: '0 0 2px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.14)',
    shadow28: '0 0 8px rgba(0,0,0,0.12), 0 14px 28px rgba(0,0,0,0.14)',
    shadow64: '0 0 8px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.14)',
    shadow2Brand: '0 0 2px rgba(0,0,0,0.30), 0 1px 2px rgba(0,0,0,0.25)',
    shadow4Brand: '0 0 2px rgba(0,0,0,0.30), 0 2px 4px rgba(0,0,0,0.25)',
    shadow8Brand: '0 0 2px rgba(0,0,0,0.30), 0 4px 8px rgba(0,0,0,0.25)',
    shadow16Brand: '0 0 2px rgba(0,0,0,0.30), 0 8px 16px rgba(0,0,0,0.25)',
    shadow28Brand: '0 0 8px rgba(0,0,0,0.30), 0 14px 28px rgba(0,0,0,0.25)',
    shadow64Brand: '0 0 8px rgba(0,0,0,0.30), 0 32px 64px rgba(0,0,0,0.25)',
};
